import React, { useEffect, useState } from 'react'

export const useGetTipoOtrosDoc = (documentos) => {

        const [finUniqTiposOtrosodoc, setFinUniqTiposOtrosodoc] = useState([])

        const getTipoOtrosDoc = () => {

                const otrosDoc =  documentos.filter(item =>  item.tipo !== 'Contrato' && item.tipo !== 'Liquidación' && item.tipo !== 'Anexo' ) 
                const tiposOtrosodoc = otrosDoc.map( ({tipo}) =>  {  return tipo } ) 
                let uniqTiposOtrosodoc = [...new Set(tiposOtrosodoc)];
                // Lo colocamos en el formato
                const Manipulardata = uniqTiposOtrosodoc.map( (i) =>  {  return {value:i, label:i} } ) 
        
                setFinUniqTiposOtrosodoc(Manipulardata)
        
        }

        useEffect(() => {
                getTipoOtrosDoc()
        }, [documentos])
        


  return {
        finUniqTiposOtrosodoc
  }
}


